import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

import { preparationHref, preparationSection } from "../../../lib/preparationNavigation";
import { useQuoteRequest } from "../../../lib/queries/quoteRequests";

/** An incoming URL is not proof that the request belongs to this dossier. */
export function PreparationReturn({ projectId }: { projectId: string }) {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const section = preparationSection(params.get("request_section"));
  const id = params.get("request") || undefined;
  const request = useQuoteRequest(section ? id : undefined);
  if (!section || !id) return null;
  if (request.isPending || request.isLoading) return <p role="status">{t("app.loading")}</p>;
  if (request.isError || request.data?.project_id !== projectId) {
    return (
      <p role="alert" className="text-red-700">
        {t("workspace.request_unavailable")}
      </p>
    );
  }
  return (
    <Link
      className="text-brand-700 inline-flex min-h-11 items-center rounded px-2 font-medium underline focus-visible:ring-2"
      to={preparationHref(id, section)}
    >
      {t("flow.return_section", { section: t(`request_flow.${section}`) })}
    </Link>
  );
}
